<template>
  <div class="md-layout page-bookinglist">
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-toolbar class="md-primary">
        <h3 class="md-title">{{ $t("Booking") }}</h3>
      </md-toolbar>
      <br />
    </div>

    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-primary">
          <div class="card-text" style="display: block;background: grey;">
            <h4 class="title">{{ $t("Booking List") }}</h4>
          </div>
        </md-card-header>
        <md-card-content>
          <md-table class="table-hover">
            <md-table-head>{{ $t("package") }}</md-table-head>
            <md-table-head>{{ $t("flight reviewer email") }}</md-table-head>
            <md-table-head>{{ $t("flight reviewer phone no") }}</md-table-head>
            <md-table-head>{{ $t("booking time") }}</md-table-head>
            <md-table-head>{{ $t("Fee") }}</md-table-head>
            <md-table-head>{{ $t("Edit") }}</md-table-head>
            <md-table-row
              v-for="(item, position) in bookingList"
              :key="position"
            >
              <md-table-cell>{{ item.package_title }}</md-table-cell>
              <md-table-cell>{{ item.reviewer_email }}</md-table-cell>
              <md-table-cell>{{ item.reviewer_phone }}</md-table-cell>
              <md-table-cell>
                <div>
                  {{
                    moment(item.booking_start_time.$date)
                      .tz(item.review_timezone)
                      .format("YYYY-MM-DD HH:mm")
                  }} - {{ 
                    moment(item.booking_end_time.$date)
                      .tz(item.review_timezone)
                      .format("HH:mm")
                  }}
                </div>
                <div>({{ item.review_timezone }})</div>
              </md-table-cell>
              <md-table-cell
                >$
                {{
                  ((+item.price + item.tax_payment) / 100).toFixed(2)
                }}</md-table-cell
              >
              <md-table-cell class="btn-wrapper">
                <md-button
                  @click="toReschedule(item)"
                  v-if="item.booking_start_time.$date > hrs48"
                  class="md-primary md-just-icon  md-simple"
                  ><md-icon>edit</md-icon></md-button
                >
                <md-button class="md-just-icon  md-simple" v-else disabled
                  ><md-icon>edit</md-icon></md-button
                >
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import { findBooking } from "@/services/flightReview.service.js";
import moment from "moment-timezone";

export default {
  data() {
    return {
      bookingList: [],
      hrs48: +new Date() + 48 * 60 * 60 * 1000 // 48 hours
    };
  },
  mounted() {
    this.getBookingList();
  },
  methods: {
    async getBookingList() {
      const res = await findBooking();
      console.log(res);
      this.bookingList = res;
    },
    moment: function(date) {
      return moment(date);
    },
    toReschedule(item) {
      this.$router.push(
        `/flight-review/reschedule?id=${item._id.$oid}&reviewerId=${item.reviewer_id}&startTime=${item.booking_start_time.$date}&endTime=${item.booking_end_time.$date}&packageTitle=${item.package_title}&status=${item.event_status}`
      );
    }
  }
};
</script>

<style lang="css">
.page-bookinglist {
  .btn-wrapper .md-table-cell-container {
    padding-left: 0;
  }
  .md-table-cell-container .md-button {
    height: 32px;
    width: 90px;
  }
}
</style>
